"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Device {
}
exports.default = Device;
//# sourceMappingURL=Device.js.map